module.exports = __webpack_public_path__ + "img/messaging-icon.e409e6c6.svg";